module.exports = "https://hwyhw-static.smarket.net.cn/519/seminar/2202102963240899/minisite/1e053e0cb6b1d8cbd5908f82f238d96c.png";